import { useDispatch } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import A from './ActionCreators';

  let acceptBlue = "rgb(0,59,156)";
export default function InviteNotification({

  setOpen,
  setAnchorEl,
  menuItem
}){

  const dispatch = useDispatch();


  let buttons = (

    <div class="sg-row v-center">

      <div class="hoverable bold">Ignore</div>

      <div style={{width:5}}/>


      <div onClick={e => {
        e.stopPropagation();
        let mi = menuItem;

        debugger;
        dispatch(A.respondToInvite({
          inviteId:mi.invite._id,
          response:true
        }))

        setOpen(false);
        setAnchorEl(null);


      }} class="faint-blue-hoverable bold" style={{
        padding:2,
        border:`1px solid ${acceptBlue}`,
        fontWeight:'bold', borderRadius:20, 
        color:acceptBlue,//'navyblue',
      }}>
        Accept
      </div>
    </div>

  )


  return (
    <MenuItem 
      disableRipple


      onClick={menuItem.onClick}>
      <div style={{
        fontSize:18,
      }} class="sg-row full-height flex-expand rel ">
        <div style={{
          top:0,
          //border:'3px solid red',
          width:20,
          height:'100%',
          //height:'100%',
        }} class="full-height rel">

          
        <div style={{ 
          background:'royalblue',
          width:12, height:12,
          borderRadius:15, marginRight:15,
          left:'50%',
          transform:'translate(-25%,75%)',
        }}/>
        </div>

        <div style={{
          //border:'3px solid purple',
        }} class="sg-col full-width">


          <div class="sg-row">
            <div style={{
              //border:'3px solid yellow',
            }} class="full-height">
            </div>
            

            <div>
              {menuItem.text}
            </div>

            <div style={{width:40}}/>
          </div>
          <div class="full-width sg-row">
            <div class="flex-expand"/>
            {buttons}
          </div>
        </div>
      </div>
    </MenuItem>
  )
  
}
